<template>
	<v-container :id="`empty-playlist${playlist?.PlaylistID ? `-${playlist.PlaylistID}` : ''}`"
		:data-playlist-id="playlist?.PlaylistID"
		class="d-flex flex-column align-center justify-center"
		style="height: 500px">
		<div class="text-h1 mb-4">Add Events To Stop Dead Air</div>
		<div class="text-h2">
			Oh no there's no audio here. Drag in new audio events or check your connection
			to GSelector.
		</div>
		<v-img src="@/assets/images/headphones.png" max-height="250" width="100%"/>
		<v-btn variant="outlined" color="primary" @click="openLibrary()">
			Go To Library
		</v-btn>
		<v-btn v-if="createPlaylistBtnEnabled" class="my-2" variant="outlined" color="secondary"
			@click="$emit('createPlaylist')">
			Create New Playlist
		</v-btn>
		<div class="drop-target-indicator" :class="`${dropTargetEvent.blink ? 'blink' : ''}`" v-if="dropTargetEvent">
			<v-btn icon width="18" height="18">
				<v-icon>mdi-plus-circle</v-icon>
			</v-btn>
		</div>
	</v-container>
</template>

<script>
import emitter from "@/emitter";

export default {
	name: "PlaylistEmptyContainer",

	props: ["playlist", "dropTargetEvent", "createPlaylistBtnEnabled"],

	emits: ["createPlaylist"],

	methods: {
		openLibrary() {
			emitter.emit("openLibrary");
		}
	}
}
</script>

<style lang="scss" scoped>
.v-container {
	color: $grey-400;
	text-align: center;

	> .v-btn {
		font-size: 16px;
	}
}

.drop-target-indicator {
	background-color: $ihm-orange;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 4px;
	width: 100%;
	position: relative;
	z-index: 2;
	transition: all 0.5s ease;
	top: 20px;

	> .v-btn {
		background-color: #fff;
		color: $ihm-orange !important;
	}
}
</style>